import React from "react";

import { FieldArray } from "formik";
import CustomSelect from "../Form/CustomSelect";
import FormInput from "../Form/FormInput";

export default class StudiesInfo extends React.PureComponent {
  state = {
    studiesInfoShowing: true,
  };

  componentDidMount() {
    if (window.innerWidth < 560) {
      this.setState({
        studiesInfoShowing: false,
      });
    }
  }

  render() {
    const {
      errors,
      setFieldValue,
      touched,
      values,
      readOnly,
      sys: { studyAreas = [] },
    } = this.props;
    return (
      <div
        className={
          this.state.studiesInfoShowing
            ? "profile-form-section"
            : "profile-form-section mobile-tab-collapsed"
        }
      >
        <FieldArray name="studyAreas">
          {(arrayHelpers) => {
            return (
              <React.Fragment>
                <div className="flex mobile-flex-justify-space flex-align-center mt-48 mb-8">
                  <p
                    className="accent-text-dark medium-text fw-700"
                    onClick={() => {
                      this.setState({
                        studiesInfoShowing: !this.state.studiesInfoShowing,
                      });
                    }}
                  >
                    Schools Studies
                  </p>
                  {readOnly ? null : (
                    <i
                      className={`material-icons link-text profile-add-icon ml-16 ${
                        !this.state.studiesInfoShowing ? "hidden" : ""
                      }`}
                      onClick={() => {
                        arrayHelpers.unshift({
                          areaOfStudy: "",
                        });
                      }}
                    >
                      add_circle
                    </i>
                  )}
                </div>
                <div className="profile-form-studies-info">
                  {values.studyAreas && values.studyAreas.length > 0 ? (
                    <div className="flex mb-16 mt-12 mobile-hidden profile-form-studies-info-grid">
                      <p className="accent-text small-text study-area">
                        Area of Study
                      </p>
                      <p />
                    </div>
                  ) : null}
                  {values.studyAreas &&
                    values.studyAreas.map((studyArea, index) => (
                      <div
                        key={index}
                        className="flex flex-align-center flex-justify-space mb-8 hover-delete-container mobile-card"
                      >
                        <div
                          className="profile-form-studies-info-grid"
                          style={{ width: "100%" }}
                        >
                          <div className="relative">
                            <FormInput
                              label="Area of Study"
                              name={`studyAreas[${index}]`}
                              errors={errors}
                              touched={touched}
                              className="custom-input mr-12"
                              style={{ flex: "2" }}
                            >
                              {({ field }) => (
                                <CustomSelect
                                  placeholder="Select Type..."
                                  errors={errors}
                                  touched={touched}
                                  readOnly={readOnly}
                                  {...field}
                                  options={studyAreas.map((s) => ({
                                    key: s.enumValue,
                                    value: s.enumValue,
                                    label: s.displayValue,
                                  }))}
                                  setFieldValue={setFieldValue}
                                />
                              )}
                            </FormInput>
                          </div>
                          {readOnly ? null : (
                            <i
                              className="material-icons link-text hover-delete"
                              style={{ fontSize: "16px" }}
                              onClick={() => arrayHelpers.remove(index)}
                            >
                              delete
                            </i>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </React.Fragment>
            );
          }}
        </FieldArray>
      </div>
    );
  }
}
